import { styled } from '@material-ui/core/styles';
import { Box, Paper } from '@material-ui/core';

export const ActivityPanelContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  margin: `${theme.spacing(2)}px ${theme.spacing(2)}px 0 ${theme.spacing(2)}px`,
  borderBottom: 'none',
  borderRadius: '12px 12px 0 0',
}));

export const ActivityFeed = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: 0,
  width: '100%',
  minHeight: '100vh',
}));

export const ActivityGroup = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const ActivityGroupHeader = styled(Box)(({ theme }) => ({
  fontFamily: 'Red Hat Display',
  marginBottom: theme.spacing(1),
  color: theme.palette.text.primary,
}));

export const ActivityItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(2),
  padding: theme.spacing(1),
}));

export const ActivityIcon = styled(Box)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(2),
  backgroundColor: '#f8f9fa',
  border: '1px solid #e9ecef',
  color: '#495057',
  '& svg': {
    width: 16,
    height: 16,
  },
}));

export const ActivityContent = styled(Box)(() => ({
  flex: 1,
}));

export const ActivityTimestamp = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
  fontWeight: 'bold',
}));

export const ActivityDescription = styled(Box)(({ theme }) => ({
  fontSize: '1rem',
  color: theme.palette.text.secondary,
  lineHeight: 1.4,
  whiteSpace: 'pre-line',
}));

export const StyledForm = styled('form')(({ theme }) => ({
  '& .MuiTextField-root': {
    marginBottom: theme.spacing(1),
  },
}));
